/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { postEventRequest } from '../../api/analytics/analytics.requests';
import { EVENT_TYPE_VERSIONS } from '../../constants';
import { useAnalyticsStore } from '../../stores/analytics/analytics.store';
import { AnalyticEvent } from '../../types/analytics';
import { sessionStartEvent } from './session';

const { getState } = useAnalyticsStore;

export const postEvent = async (event: AnalyticEvent) => {
  const { sessionId, incrementSessionOrder } = useAnalyticsStore.getState();

  if (!sessionId && event.eventType !== 'session_start') {
    await sessionStartEvent();
  }

  const response = await postEventRequest({
    eventType: event.eventType,
    eventTypeVersion: EVENT_TYPE_VERSIONS[event.eventType] || 0,
    timestamp: Date.now(),
    data: {
      session_id: getState().sessionId || 'noSessionId',
      session_order: getState().sessionOrder + 1,
      ...('data' in event ? event.data : {}),
    },
  });

  if (response.status === 204) {
    incrementSessionOrder();
  }

  return response;
};

export const buttonClickEvent = (buttonId: string, pageId: string) => {
  const { userConsent, resetExpiration } = useAnalyticsStore.getState();

  if (userConsent) {
    void postEvent({
      eventType: 'button_click',
      data: {
        button_id: buttonId,
        page_id: pageId,
      },
    });
    resetExpiration();
  }
};
